import { Typography } from '@mui/material';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import AttendanceStubImg from '../../../../../assets/images/attendance-stub.svg';
import { GroupPreviewAttendanceEmptyStubStyled } from './GroupPreviewAttendanceEmptyStub.styled';

export const GroupPreviewAttendanceEmptyStubNoButton: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <GroupPreviewAttendanceEmptyStubStyled>
      <img src={AttendanceStubImg} alt={formatMessage({ id: 'attendance-NoAttendanceYet' })} />
      <Typography variant="h3" color="text.primary" mt={2.5} textAlign="center">
        <FormattedMessage id="attendance-NoRegisterForSchoolYear" />
        <br />
      </Typography>
    </GroupPreviewAttendanceEmptyStubStyled>
  );
};
